// How far a tier got: how many of its tasks are done.
//
// CORE PUBLISHES NO SUCH COUNT. There is no route that answers "the progress of
// this tier", so it is built from the `pagination.total` of four task listings
// — all of them, the done, the discarded and the proposed ones — each asked
// with `limit: 1`, because the number is the answer and the rows are not.
//
// THE INDEX IS OVER AUTHORIZED WORK: done over the tasks somebody decided to
// do. Two kinds leave the denominator, for opposite reasons:
//
//   discarded  it will not be done, and counting it would leave a finished tier
//              short of 100% forever — a number people stop trusting;
//   proposed   NOBODY HAS DECIDED IT YET. A proposal is a suggestion until a
//              person authorizes it, so measuring against it would move the
//              index every time an agent writes one down, which is not progress
//              going backwards — it is the question changing.
//
// The proposals are still counted and shown NEXT TO the index, because a tier
// with work waiting for a decision is not finished business either.
//
// WHAT THE COUNT IS SCOPED TO: `total` counts what the session can see, like
// every listing. Two people can read different denominators, and neither is
// wrong.

export function readProgress({ total, done, discarded, proposed } = {}) {
    const known = [total, done, discarded, proposed].every(value => typeof value === 'number');
    if (!known) return { known: false, counted: 0, done: 0, complete: false, ratio: 0, proposed: 0 };

    const counted = Math.max(0, total - discarded - proposed);
    const finished = Math.min(done, counted);

    return {
        known: true,
        counted,
        done: finished,
        proposed,
        // A tier with nothing authorized is NOT complete: there is nothing to
        // have finished. Saying «completado» there would call an empty tier —
        // or one that is all proposals — done.
        complete: counted > 0 && finished === counted,
        ratio: counted > 0 ? finished / counted : 0,
    };
}

// The three filters of the list. `completed` is read from the URL, so a filtered
// view survives a reload and can be linked.
export const COMPLETION_FILTERS = [
    { key: '',      label: 'Todos' },
    { key: 'abiertos', label: 'Ocultar completados' },
    { key: 'completados', label: 'Solo completados' },
];

export function matchesCompletion(progress, filter) {
    if (!filter) return true;
    // While the counts are still in flight nothing is hidden: a row that
    // disappears and comes back is worse than one that arrives a moment late.
    if (!progress?.known) return true;
    return filter === 'completados' ? progress.complete : !progress.complete;
}
